import { Box, styled } from '@mui/material';

import {
  GRID_AREA_ACCOUNT,
  GRID_AREA_ARROW,
  GRID_AREA_NAME,
  GRID_AREA_AVATAR
} from './UserSelector.constants';

const visibleSwitcher = `
"${GRID_AREA_AVATAR} ${GRID_AREA_NAME} ${GRID_AREA_ARROW}"
"${GRID_AREA_AVATAR} ${GRID_AREA_ACCOUNT} ${GRID_AREA_ARROW}"
`;

const unVisibleSwitcher = `
"${GRID_AREA_AVATAR} ${GRID_AREA_NAME}"
"${GRID_AREA_AVATAR} ${GRID_AREA_ACCOUNT}"
`;

const mixinWithSwitcher = `
  grid-template-areas: ${visibleSwitcher};
  grid-template-columns: 40px auto 40px;
`;

const mixinWithoutSwitcher = `
  grid-template-areas: ${unVisibleSwitcher};
  grid-template-columns: 40px auto;
`;

interface StyledUserSelectorProps {
  shouldShowAccountSwitcher: boolean;
}

export const StyledUserSelector = styled(Box, {
  shouldForwardProp: (prop: PropertyKey) => prop !== 'shouldShowAccountSwitcher'
})<StyledUserSelectorProps>`
  width: 100%;
  display: grid;
  align-items: center;
  padding: ${({ theme }) => theme.spacing(1, 2)};
  column-gap: ${({ theme }) => theme.spacing(1)};

  ${({ shouldShowAccountSwitcher }) =>
    shouldShowAccountSwitcher ? mixinWithSwitcher : mixinWithoutSwitcher};
`;
